import { Button, Flex } from '@chakra-ui/react';
import { useState } from 'react';

import Dialog from '@app/components/common/modals/dialog';
import { Txt } from '@app/components/common';
import { Equipment } from '@app/api/models';
import { useAlert } from '@app/hooks';

import { ActionDialogProps } from './types';
import { EquipField } from '../dialogs/components/EquipField';

export const SendEquipDialog = ({ onAction, selectedTx, isPackage, actionName }: ActionDialogProps) => {
  const [open, setOpen] = useState(false);
  const [equip, setEquip] = useState<Equipment>();
  const { error } = useAlert();

  const onSubmit = () => {
    if (isPackage) {return;}
    if (!equip) {
      error('Не выбрано ХО');
      return;
    }

    onAction({ ...selectedTx, equip: {
      id: Number(equip.id),
      serial_num: equip.serial_num,
      inventory_num: equip.inventory_num,
      model: equip.model,
    } });
    setOpen(false);
  };

  if (isPackage) {
    return null;
  }

  return <>
    <Button colorScheme='green' onClick={() => setOpen(true)} >{actionName}</Button>
    <Dialog
      width='600px'
      open={open}
      title="Отправка ХО"
      onClose={() => setOpen(false)}
    >
      <Flex flexDirection='column' gap={4} mb={-4}>
        <Txt>Подтвердить отправку ХО?</Txt>
        <EquipField
          value={equip}
          onChange={setEquip} 
          id="equip"        
        />
        <Flex justifyContent='right'>
          <Button isDisabled={!equip} variant='solid' colorScheme='green' key='cancel' onClick={onSubmit}>Подтвердить</Button>
        </Flex>
      </Flex>
    </Dialog>
  </>;
};